export const ApplicationLifecycleStatus = {
  draft: 'draft',
  submitted: 'submitted',
  working: 'working',
  approved: 'approved',
  complete: 'complete',
  signed: 'signed',
  active: 'active',
  rejected: 'rejected',
  cancel: 'cancel',
  repaid: 'repaid',
} as const

export type ApplicationLifecycleStatus =
  (typeof ApplicationLifecycleStatus)[keyof typeof ApplicationLifecycleStatus]

export type ApplicationLifecycleStatusChipColor = 'brand' | 'success' | 'warning' | 'danger' | 'muted'

const applicationLifecycleStatusChipColor: Record<ApplicationLifecycleStatus, ApplicationLifecycleStatusChipColor> = {
  draft: 'muted',
  submitted: 'brand',
  working: 'warning',
  approved: 'success',
  complete: 'warning',
  signed: 'success',
  active: 'success',
  rejected: 'danger',
  cancel: 'muted',
  repaid: 'success',
}

export const getApplicationLifecycleStatusChipColor = (status: ApplicationLifecycleStatus) =>
  applicationLifecycleStatusChipColor[status]
